/// Port of AppRoutes from mobile/lib/app/router/app_router.dart.

export const appRoutes = {
  home: '/',
  settings: '/settings',
  rank: '/rank',
  stats: '/stats',
  auth: '/auth',
  verifyEmail: '/verify-email',
  resetPassword: '/reset-password',
  user: '/user',
  changeUsername: '/user/username',
  changeEmail: '/user/email',
  changePassword: '/user/password',
  offline: '/offline',
  serverUnavailable: '/server-unavailable',
  maintenance: '/maintenance',
  forceUpdate: '/update',
  support: '/support',
  notFound: '/not-found',
} as const;

/// Matches the go_router fade duration.
export const routeTransitionMs = 120;
